const React = require('react');

// Presentation deadline only. Requests remain active and late data is accepted.
const useSlowResource = (loading, identity) => {
    const [slow, setSlow] = React.useState(false);
    React.useEffect(() => {
        setSlow(false);
        if (!loading) return undefined;
        const timer = setTimeout(() => setSlow(true), 15000);
        return () => clearTimeout(timer);
    }, [loading, identity]);
    return loading && slow;
};

module.exports = useSlowResource;
